import guestClient from './guestClient';

export const fetchGuestSummary = async () => {
  const res = await guestClient.get('/api/guest/summary');
  return res.data;
};

export const fetchGuestMe = async () => {
  const res = await guestClient.get('/api/guest/me');
  return res.data;
};

export const updateGuestMe = async (payload) => {
  const res = await guestClient.put('/api/guest/me', payload);
  return res.data;
};

export const changeGuestPassword = async (payload) => {
  const res = await guestClient.put('/api/guest/change-password', payload);
  return res.data;
};

export const uploadGuestAvatar = async (file) => {
  const form = new FormData();
  form.append('avatar', file);
  const res = await guestClient.post('/api/guest/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const fetchGuestBookings = async (params = {}) => {
  const res = await guestClient.get('/api/guest/bookings', { params });
  return res.data;
};

export const fetchGuestBooking = async (id) => {
  const res = await guestClient.get(`/api/guest/bookings/${id}`);
  return res.data;
};

export const cancelGuestBooking = async (id) => {
  const res = await guestClient.patch(`/api/guest/bookings/${id}/cancel`);
  return res.data;
};

export const fetchGuestBookingInvoice = async (id) => {
  const res = await guestClient.get(`/api/guest/bookings/${id}/invoice`);
  return res.data;
};

export const fetchGuestUpcoming = async (params = {}) => {
  const res = await guestClient.get('/api/guest/upcoming', { params });
  return res.data;
};

export const fetchMessageThreads = async (params = {}) => {
  const res = await guestClient.get('/api/messages/threads', { params });
  return res.data;
};

export const fetchThreadMessages = async (threadId, params = {}) => {
  const res = await guestClient.get(`/api/messages/threads/${threadId}/messages`, { params });
  return res.data;
};

export const createMessageThread = async (payload) => {
  const res = await guestClient.post('/api/messages/threads', payload);
  return res.data;
};

export const sendThreadMessage = async (threadId, payload) => {
  const res = await guestClient.post(`/api/messages/threads/${threadId}/messages`, payload);
  return res.data;
};

export const markThreadRead = async (threadId) => {
  const res = await guestClient.patch(`/api/messages/threads/${threadId}/read`);
  return res.data;
};

export const fetchGuestPayments = async (params = {}) => {
  const res = await guestClient.get('/api/guest/finance/payments', { params });
  return res.data;
};

export const fetchGuestRefunds = async (params = {}) => {
  const res = await guestClient.get('/api/guest/finance/refunds', { params });
  return res.data;
};

export const requestGuestRefund = async (payload) => {
  const res = await guestClient.post('/api/guest/finance/refunds/request', payload);
  return res.data;
};

export const fetchGuestPayment = async (id) => {
  const res = await guestClient.get(`/api/guest/finance/payments/${id}`);
  return res.data;
};

export const createGuestFinancePayment = async (bookingId) => {
  const res = await guestClient.post('/api/guest/finance/payments/create', { bookingId });
  return res.data;
};

export const mockCaptureGuestPayment = async (paymentId) => {
  const res = await guestClient.post('/api/guest/finance/payments/mock-capture', { paymentId });
  return res.data;
};

export const createGuestPaymentIntent = async (bookingId) => {
  const res = await guestClient.post(`/api/guest/payments/${bookingId}/create-intent`);
  return res.data;
};

export const fetchGuestPaymentReceipt = async (bookingId) => {
  const res = await guestClient.get(`/api/guest/payments/${bookingId}/receipt`);
  return res.data;
};

export const markGuestPaymentPaid = async (paymentId) => {
  const res = await guestClient.post(`/api/guest/payments/${paymentId}/mark-paid`);
  return res.data;
};

export const fetchGuestWishlist = async () => {
  const res = await guestClient.get('/api/guest/wishlist');
  return res.data;
};

export const toggleGuestWishlist = async (propertyId) => {
  const res = await guestClient.post(`/api/guest/wishlist/${propertyId}`);
  return res.data;
};

export const removeGuestWishlist = async (propertyId) => {
  const res = await guestClient.delete(`/api/guest/wishlist/${propertyId}`);
  return res.data;
};

export const fetchGuestSupportTickets = async (params = {}) => {
  const res = await guestClient.get('/api/guest/support/tickets', { params });
  return res.data;
};

export const fetchGuestSupportTicket = async (ticketId) => {
  const res = await guestClient.get(`/api/guest/support/tickets/${ticketId}`);
  return res.data;
};

export const createGuestSupportTicket = async (payload) => {
  const res = await guestClient.post('/api/guest/support/tickets', payload);
  return res.data;
};

export const closeGuestSupportTicket = async (ticketId) => {
  const res = await guestClient.patch(`/api/guest/support/tickets/${ticketId}/close`);
  return res.data;
};
